var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.033 11.2917C14.683 11.6334 14.483 12.125 14.533 12.65C14.608 13.55 15.433 14.2084 16.333 14.2084H17.9163V15.2C17.9163 16.925 16.508 18.3334 14.783 18.3334H5.21634C3.49134 18.3334 2.08301 16.925 2.08301 15.2V9.59172C2.08301 7.86672 3.49134 6.45837 5.21634 6.45837H14.783C16.508 6.45837 17.9163 7.86672 17.9163 9.59172V10.7917H16.233C15.7663 10.7917 15.3413 10.975 15.033 11.2917Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 10.3417V6.53342C2.08301 5.54175 2.69134 4.65838 3.61634 4.30838L10.233 1.80838C11.2663 1.41672 12.3747 2.18341 12.3747 3.29174V6.4584",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7987 11.6418V13.3586C18.7987 13.8169 18.432 14.1918 17.9653 14.2085H16.332C15.432 14.2085 14.607 13.5502 14.532 12.6502C14.482 12.1252 14.682 11.6335 15.032 11.2918C15.3404 10.9752 15.7653 10.7919 16.232 10.7919H17.9653C18.432 10.8085 18.7987 11.1835 18.7987 11.6418Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 10H11.6663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0ac00ec3fd283566ed31c526ba7b6410.svg";
export { ForwardRef as ReactComponent };